export type TReminderFilterOption = {
  label: string;
  selected: boolean;
  value: string;
};

export type TReminderFilterOptions = {
  type: EReminderFilterType;
  label: string;
  options: TReminderFilterOption[];
};

export enum EReminderFilterType {
  TYPE = 'reminder_type',
  STATUS = 'reminder_status',
  LINKED_TO = 'linked_to',
  DUE_DATE = 'due_date',
}

export type TReminderFilterDueDate = {
  from: number;
  to: number;
};

export enum EReminderFilterKeys {
  SHARED_BY_ME = 'shared_by_me',
  SHARED_WITH_ME = 'shared_with_me',
  PERSONAL = 'personal',
  UPCOMING = 'upcoming',
  DISMISSED = 'dismissed',
  OVERDUE = 'overdue',
  LINKED = 'linked',
  WITHOUT_LINK = 'without_link',
}
